export const colors = {
  primary: '#00C29B',
  primaryDark: '#008369',
  secondary: '#8338eb',
  secondaryDark: '#611EBE',
  secondaryLight: '#A25FFE',
  text: '#201f1e',
  tertiary: {
    cyan: '#00ecff',
    cyanDark: '#00C79F',
    green: '#8bdb24',
    lightGreen: '#F5FFE8',
    magenta: '#bf0d9f',
    red: '#e70411',
    orange: '#ff8f1a',
    yellow: '#ffc759',
    blue: '#54a0ff',
    aliceBlue: '#0062CC1A',
    navy: '#0062cc',
    navyDark: '#0455AD',
    navyLight: '#01D1F6',
    white: '#FFFF',
    darkGray: '#757575',
    gullGrey: '#A0AFB2',
    redBrown: '#A2191F',
    tealishGreen: '#0E6027',
    cadimiumRed: '#E70411',
  },
  gradient: {
    cyan: 'linear-gradient(180deg, #f5fffd -5.83%, #b3fff0 72.92%, #80d9ff 100%)',
    green:
      'linear-gradient(0deg, rgba(138, 219, 36, 0.54) 0%, rgba(249, 245, 134, 0.26) 100%)',
    magenta:
      'linear-gradient(180deg, rgba(0, 236, 255, 0.13) -5.83%, rgba(191, 13, 159, 0.22) 100%)',
    red: 'linear-gradient(180deg, rgba(227, 253, 245, 0.42) 29.17%, rgba(243, 172, 168, 0.49) 80.73%, rgba(255, 107, 107, 0.62) 100%)',
    orange:
      'linear-gradient(180deg, rgba(0, 236, 255, 0.06) -0.34%, rgba(255, 143, 25, 0.46) 99.66%)',
    yellow: 'linear-gradient(180deg, #f5fff9 -5.83%, #ffc759 100%)',
    blue: 'linear-gradient(0deg, rgba(84, 160, 255, 0.74) 0%, rgba(254, 214, 227, 0.22) 92.71%)',
    navy: 'linear-gradient(180deg, rgba(224, 195, 252, 0.25) 0%, rgba(0, 98, 204, 0.68) 101.67%)',
  },
  background: {
    pageBackground: '#f9f9f9',
    componentBackground: '#fff',
    lightGray: '#f8f9fb',
    midGray: '#f2f2f2',
    darkGray: '#8F918D',
    error: '#fef2f3',
    disabled: '#fafafa',
    avatarBackgound: '#D2DFD7',
    paleYellow: '#FFFADD',
    greenishYellow: '#D0ECA1',
    redOrange: '#FFD7D9',
    pearlGrey: '#e0e0e0',
    magicMint: '#A7F0BA',
    titaniumWhite: '#E5E5E5',
  },
  state: {
    selected: '#f0faff',
    hover: '#f9fdff',
  },
  hightlight: {
    light: '#fbf8e4',
    dark: '#ffcd6a',
  },
  infoSuccess: { main: '#effff9' },
  infoNeutral: { main: '#f3fbff' },
  status: {
    error: '#eb0014',
  },
  type: {
    copy: '#243d42',
    disabled: '#8d8d8d',
  },
  border: {
    focus: '#0f62fe',
    error: '#F9445E',
    warning: '#FFE99B',
    disabledGray: '#d8d8d8',
    disabledGrayDark: '#dddddd',
    mediumGrey: '#999',
    gainsboroGrey: '#DCDCDC',
    gainsboroDarkGrey: '#DFDFDF',
  },
  arrow: {
    disabled: '#c4c4c4',
  },
  accessibility: {
    focus: '#101010',
  },
  avatar: {
    borderColor: '#346C6D',
    bgColor: '#C8ECED',
    background: '#E9C7CD',
    avatarBgColor2: '#D6D4E7',
    avatarBgColor3: '#D1DADF',
    avatarFontColor1: '#420610',
    textColor1: '#326869',
    textColor2: '#316566',
  },
  tag: {
    border: '#3A5055',
  },
  black: '#000000',
  blackPearl: '#1A2027',
  purpleLight: '#A26AF0',
  scroll: {
    thumb: '#E6E6E6',
  },
  scrollBar: {
    backgound: '#b2b2b2',
    hover: '#7f7f7f',
    lightBackground: '#3F43503D',
  },
  connector: {
    border: '#D8D8D8',
  },
  chip: {
    primary: '#E5F1FF',
    secondary: '#DDE1E6',
  },
};
